function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.306 10.6189C17.0861 10.4227 16.825 10.267 16.5376 10.1608C16.2502 10.0547 15.9422 10 15.6311 10C15.3201 10 15.012 10.0547 14.7247 10.1608C14.4373 10.267 14.1762 10.4227 13.9563 10.6189L13.4999 11.0258L13.0435 10.6189C12.5993 10.2227 11.9968 10.0002 11.3686 10.0002C10.7404 10.0002 10.138 10.2227 9.69375 10.6189C9.24955 11.015 9 11.5522 9 12.1124C9 12.6726 9.24955 13.2098 9.69375 13.6059L10.1501 14.0129L13.4999 17L16.8496 14.0129L17.306 13.6059C17.526 13.4098 17.7006 13.177 17.8196 12.9207C17.9387 12.6645 18 12.3898 18 12.1124C18 11.835 17.9387 11.5603 17.8196 11.3041C17.7006 11.0478 17.526 10.815 17.306 10.6189V10.6189Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.65d9f441.svg";
export { ForwardRef as ReactComponent };